import service from "@/utils/index"
// 获取菜单权限
export const getMenu = (data) => {
    return service({
        method: "post",
        url: "/Sys/get_menu",
        data:data
    })
}